 
                        <nb-card *ngIf="stream" [nbSpinner]="loading" class="own-scroll">
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;
    margin-bottom: auto;"  [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('unlockForm')"	   (click)="panelVisibility.toggleVisibility('unlockForm')">Текст форми введення ключа</div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	
				 
   </div>
				</div>
                            </nb-card-header>
                            <nb-card-body   *ngIf="!panelVisibility.isUnvisible('unlockForm')" [@visibilityPanelAnimation] >


	<div class="d-flex">
		<div  style="padding:5px;">
			<label>Поле введення</label>
			<input  class="priceInput"  [(ngModel)]="text" nbInput fullWidth />
		 </div>


		<div  style="padding:5px;">
			<label>Кнопка</label>
			<input  class="priceInput"  [(ngModel)]="button" nbInput fullWidth />
		 </div>
       </div>

	<div  class="d-flex" style="padding:5px; "><button  style="margin-left:auto; " (click)="save()" status="primary"   nbButton>Зберегти</button></div>

  
                            </nb-card-body>
                            
                            </nb-card>
 
  


 
